<template>
  <div>
    <div class="common-title" id="TEAM-BUILDING">
      <div class="common-title-content">
        团队建设
      </div>
    </div>
    <div class="grid">
      <div class="smcaiot-photo-wall">
        <div
          class="image-item"
          v-for="(img, idx) in imgs"
          :key="idx"
          :class="'team' + (idx + 1)"
        >
          <img :src="img.imgSrc" alt="" />
          <div class="modal"></div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "teamBuilding",
  data() {
    return {
      imgs: [
        {
          imgSrc: require("@/assets/images/joinUs/team1.png")
        },
        {
          imgSrc: require("@/assets/images/joinUs/team2.png")
        },
        {
          imgSrc: require("@/assets/images/joinUs/team3.png")
        },
        {
          imgSrc: require("@/assets/images/joinUs/team4.png")
        },
        {
          imgSrc: require("@/assets/images/joinUs/team5.png")
        },
        {
          imgSrc: require("@/assets/images/joinUs/team6.png")
        },
        {
          imgSrc: require("@/assets/images/joinUs/team7.png")
        }
      ]
    };
  }
};
</script>
<style lang="less" scoped>
.smcaiot-photo-wall {
  position: relative;
  width: 100%;
  height: 63.45rem;
  margin: 0 auto;
  .image-item {
    position: absolute;
    z-index: 99;
    .modal {
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      visibility: hidden;
    }
    &.team1 {
      top: 0;
      left: 0;
      width: 65.73vw;
      height: 21.15rem;

      .modal {
        visibility: visible;
        background-color: rgba(1, 41, 202, 0.54);
      }
    }
    &.team2 {
      top: 0;
      left: 65.73vw;
      width: calc(100% - 65.73vw);
      height: 21.15rem;

      .modal {
        visibility: visible;
        background-color: rgba(143, 15, 228, 0.66);
      }
    }
    &.team3 {
      top: 21.15rem;
      left: 0;
      width: 32.89vw;
      height: 21.15rem;

      .modal {
        visibility: visible;
        background-color: rgba(36, 231, 239, 0.66);
      }
    }
    &.team4 {
      top: 21.15rem;
      left: 32.89vw;
      width: calc(100% - 32.89vw);
      height: 21.15rem;

      .modal {
        visibility: visible;
        background-color: rgba(10, 245, 90, 0.5);
      }
    }
    &.team5 {
      top: 42.3rem;
      left: 0;
      width: 33.05vw;
      height: 21.15rem;

      .modal {
        visibility: visible;
        background-color: rgba(226, 211, 34, 0.48);
      }
    }
    &.team6 {
      top: 42.3rem;
      left: 33.05vw;
      width: 33.93vw;
      height: 21.15rem;

      .modal {
        visibility: visible;
        background-color: rgba(226, 211, 34, 0.48);
      }
    }
    &.team7 {
      top: 42.3rem;
      left: 66.98vw;
      width: calc(100% - 66.98vw);
      height: 21.15rem;

      .modal {
        visibility: visible;
        background-color: rgba(226, 211, 34, 0.48);
      }
    }
    img {
      width: 100%;
      height: 100%;
    }
  }
}
</style>
